import { Component, Input } from "@angular/core"

@Component({
    selector: "app-logo",
    templateUrl: "./logo.component.html",
    styleUrls: ["./logo.component.less"],
})
export class LogoComponent {
    @Input() public logoUrl: string
    @Input() public name?: string
    @Input() public role?: string
}
